import logixPanelInstance from 'i18n';
import { useTranslation } from 'react-i18next';
import NotificationBadge from 'components/NotificationBadge';
import { useNotificationStore } from 'store';
import { MLARole } from '../../hooks/useGetMLAApplicationList';
import { Style } from './style';

type RoleTabsProps = {
  activeRole: MLARole;
  onRoleChange: (role: MLARole) => void;
};

const RoleTabs = (props: RoleTabsProps): JSX.Element => {
  const { activeRole, onRoleChange } = props;

  const { t } = useTranslation('mla', {
    i18n: logixPanelInstance
  });

  const notification = useNotificationStore((state) => state.notification);
  const masterPendingCount = Number(notification.mlaMaster) || 0;
  const agentPendingCount = Number(notification.mlaAgent) || 0;

  return (
    <Style.RoleTabs>
      <Style.RoleTab
        type="button"
        $isActive={activeRole === 'master'}
        onClick={() => onRoleChange('master')}
      >
        {t('master')}
        {masterPendingCount > 0 && (
          <NotificationBadge messagesNumber={masterPendingCount} />
        )}
      </Style.RoleTab>
      <Style.RoleTab
        type="button"
        $isActive={activeRole === 'agent'}
        onClick={() => onRoleChange('agent')}
      >
        {t('agent')}
        {agentPendingCount > 0 && (
          <NotificationBadge messagesNumber={agentPendingCount} />
        )}
      </Style.RoleTab>
    </Style.RoleTabs>
  );
};

export default RoleTabs;
